import React from "react";
import Layout from "../LayoutStaticPage";
import CheckIcon from "../../../../icons/CheckIcon";

const TermsAndConditions = () => {
  interface textContentData {
    title?: string;
    children?: React.ReactNode;
  }
  const termsAndConditionData: textContentData[] = [
    {
      title: "Definitions",
      children: (
        <div>
          <ul className="space-y-3">
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  01
                </p>
                <p>
                  <strong className="font-semibold ">Agreement </strong>
                  means the terms and conditions of this End User terms and
                  conditions Agreement.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  02
                </p>

                <p>
                  <strong className="font-semibold ">Claim </strong>
                  shall mean any liability, suits, claims, actions, proceedings,
                  losses, damages, judgments and reasonable costs.
                </p>
              </div>
            </li>
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  03
                </p>

                <p>
                  <strong className="font-semibold ">Documentation </strong>
                  shall mean the instructions and/or user manuals that describe
                  installation, use, and/or operation of the Software.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  04
                </p>

                <p>
                  <strong className="font-semibold ">Improvements </strong>
                  shall mean, with respect to the platform, all modifications
                  and changes made, developed, acquired or conceived after the
                  date hereof and during the entire term of this Agreement.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  05
                </p>
                <p>
                  <strong className="font-semibold ">
                    Intellectual Property Rights{" "}
                  </strong>
                  shall mean copyright, patents, designs, trademarks, trade
                  names, goodwill rights and trade secrets.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  06
                </p>

                <p>
                  <strong className="font-semibold "> Website </strong>
                  refers to any and all versions of the software that has been
                  developed and is owned by the Company and available for
                  download and/or purchase from the Website.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  07
                </p>

                <p>
                  <strong className="font-semibold ">Software </strong>
                  means and includes means the object code version of any
                  software to which Customer is provided access as part of the
                  service, including any updates or new versions.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  08
                </p>

                <p>
                  <strong className="font-semibold ">Source Code </strong>
                  is the computer programming source code form of the Software
                  in the form maintained by the Company, and includes all
                  non-third-Party executables, libraries, components, and
                  Documentation created or used in the creation, development,
                  maintenance, and support of the Software as well as all
                  updates, error corrections and revisions thereto provided by
                  Company, in whole or in part.
                </p>
              </div>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Terms and Conditions",
      children: (
        <div className="space-y-5">
          <p>The User shall not use the Software or the Website to:</p>
          <div>
            {/* Main List */}
            <ul className="space-y-3">
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    01
                  </p>
                  <p>
                    Abuse, harass, threaten, defame, disillusion, erode,
                    abrogate, demean or otherwise violate the legal rights of
                    any other person or entity;
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    02
                  </p>

                  <p>
                    Engage in any activity that interferes with or disrupts
                    access to the Website or the services provided therein (or
                    the servers and networks which are connected to the
                    Website);
                  </p>
                </div>
              </li>
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    03
                  </p>

                  <p>
                    Impersonate any person or entity, or falsely state or
                    otherwise misrepresent their affiliation with a person or
                    entity;
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    04
                  </p>

                  <p>
                    Publish, post, disseminate, any information which is grossly
                    harmful, harassing, blasphemous, defamatory, obscene,
                    pornographic, pedophilic, libelous, invasive of another's
                    privacy, hateful, or racially, ethnically objectionable,
                    disparaging, relating or encouraging money laundering or
                    gambling, or otherwise unlawful in any manner whatever under
                    any law, rule or regulation currently in force; or
                    unlawfully threatening or unlawfully harassing including but
                    not limited to "indecent representation of women" within the
                    meaning of the Indecent Representation of Women
                    (Prohibition) Act, 1986;
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    05
                  </p>
                  <p>
                    Infringe the copyright, patent or trademark of another
                    person or legal entity;
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    06
                  </p>

                  <p>
                    Reverse engineer, disassemble, or decompile the Software and
                    Website. The User may neither modify, rent, or resell this
                    Software and Website for profit, nor create derivative works
                    based upon this Website or Software.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    07
                  </p>

                  <p>
                    Use the Website, Software or Output other than as expressly
                    provided by the license you purchased with respect to such
                    Website.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    08
                  </p>

                  <p>
                    Falsely represent, expressly or by way of reasonable
                    implication, that the Website or Software was created by you
                    or a person other than the copyright holder of the Website
                    and Software, namely the Website.
                  </p>
                </div>
              </li>
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    09
                  </p>

                  <p>
                    Sale or distribution of registered copies of the Website and
                    Software is strictly forbidden. It is a violation of this
                    agreement to loan, rent or resell, lease, borrow, or
                    transfer the use of registered copies of the Website.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    09
                  </p>

                  <p>You agree to abide by the following conditions:</p>
                </div>
              </li>
            </ul>
            {/* Sublist */}
            <ul className="ml-6 mt-2 space-y-3">
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.1
                  </p>

                  <p>
                    We are a mere host that is a market place bringing all the
                    properties under auction by various lending institutes /
                    regulatory authorities, and these auctions will be held ‘AS
                    IS WHERE IS’ and ‘AS IS WHAT IS BASIS’, as stated in the
                    disclaimer policy.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.2
                  </p>

                  <p>
                    The e-auction of properties will be conducted by the
                    respective institute/authority as mentioned in the auction
                    notices, can be referred in specific notice with or without
                    our involvement as auction facilitating agency.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.3
                  </p>

                  <p>
                    The interested buyers are bound by the principle of caveat
                    emptor (the principle that the buyer alone is responsible
                    for checking the quality and suitability of goods before a
                    purchase is made).
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.4
                  </p>

                  <p>
                    The property is being auctioned with the details to the
                    extent best of knowledge and information of the Authorised
                    Officers, there are no encumbrances on the properties except
                    those mentioned in the Notice.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.5
                  </p>

                  <p>
                    We waive all liability towards the verification of property
                    and the users. We are merely a platform that hosts these
                    auctions. The interested buyers also can make their own
                    independent inquiries regarding the encumbrances, title of
                    property, specification, claims/rights/dues etc. effecting
                    the property. Or they can opt for any Independent legal and
                    technical experts’ assistance.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.6
                  </p>

                  <p>
                    Further the bidder/purchaser should make their own inquiries
                    regarding property offered for sale or for any dues like
                    outstanding water/service charges, transfer fees,
                    electricity dues, dues to the Municipal. As seller does not
                    undertake any responsibility to procure any
                    permission/license, NOC, etc. All users must take precaution
                    and conduct due diligence. We will not be liable for any
                    disputes arising out of the same.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.7
                  </p>

                  <p>
                    The Authorised Officer/ Secured Creditor/Service Provider
                    shall not be responsible in any way for any third-party
                    claims/ rights/ dues etc.Where the Immovable Properties are
                    subject matter of any suit, application, proceedings or Lis
                    Pendens (i.e., a pending legal action, or a formal notice of
                    one) before any court, tribunal, forum or any other
                    authority, the scheduled sale will be subject to the order
                    of such court, tribunal, forum or any other authority.
                  </p>
                </div>
              </li>{" "}
              <li className="flex items-center">
                <div className="flex">
                  <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                    9.8
                  </p>

                  <p>
                    The inspection of property put on auction will be permitted
                    after consultation of the respective bank.
                  </p>
                </div>
              </li>{" "}
            </ul>
          </div>
        </div>
      ),
    },
    {
      title: "Intellectual Property Indemnification",
      children: (
        <div className="space-y-5">
          <p>
            You will indemnify and hold the Company harmless from any
            third-party claim brought against the Company claiming that the
            Website infringes or misappropriates patent, copyright, trademark,
            trade secret, or other intellectual property rights of a third party
            due to modifications or usage by You, or due to any breach of this
            Agreement or due to breach of any license terms by You.
          </p>
        </div>
      ),
    },
    {
      title: "Warranties and Representations",
      children: (
        <div className="space-y-5">
          <p>
            You hereby expressly agree and acknowledge that, except as provided
            in this Agreement, the Software is provided 'as is' and “as
            available” without any representations, conditions, warranties or
            covenants whatsoever concerning the Software, including without
            limitation, any express, statutory or implied representations,
            warranties or conditions of merchantability, merchantable quality,
            satisfactory quality or fitness for a particular purpose, or arising
            otherwise in law or from a course of dealing or usage of trade, all
            of which are expressly disclaimed and excluded. The Company does not
            warrant that the Software shall be error-free or will perform
            uninterruptedly.
          </p>
        </div>
      ),
    },
    {
      title: "Indemnification",
      children: (
        <div className="space-y-5">
          <p>
            You shall indemnify and hold the Company harmless from claims,
            liabilities, damages, cost (inclusive of all Legal Costs), expenses
            arising out of:
          </p>

          <ul className="space-y-3">
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  01
                </p>
                <p>
                  Any willful default or negligent act committed by You or any
                  of Your officials or employees in relation to the performance
                  of this Agreement.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  02
                </p>

                <p>Any breach of third-party rights.</p>
              </div>
            </li>
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  03
                </p>

                <p>
                  Non-compliance with law in case of any notice, summons or
                  memorandum or consumer complaint received from any Statutory
                  Authority or in the event of institution of litigation against
                  You for default, or any non-compliance with laws that are
                  directly attributable to You, and You shall indemnify the
                  Company against any awarded damages, compensation or
                  reasonable legal fees arising out of such default or
                  non-compliance thereof directly attributable to You.
                </p>
              </div>
            </li>{" "}
          </ul>
        </div>
      ),
    },
    {
      title: "Limitation of Liability",
      children: (
        <div className="space-y-5">
          <p>
            In no event shall the company be liable to you or a third party for
            any special, punitive, indirect, incidental or consequential damages
            (including loss of use, data, business or profits, business
            interruption) arising out of or in connection with this agreement or
            the use or performance of the software, whether such liability
            arises from any claim based upon contract, warranty, tort (including
            negligence), Website liability or otherwise, and whether or not you
            or the third party has been advised of the possibility of such loss
            or damage.
            <br />
            <br /> n any event, company’s maximum aggregate liability (whether
            in contract or under any other form or liability) for damages or
            loss, howsoever arising or caused, whether or not arising from
            company’s negligence, shall not be in excess of the prorated amount
            of license fees paid to company hereunder in preceding three (03)
            months of the event which is giving right to such claim. The
            foregoing liability cap shall apply notwithstanding the failure of
            essential purpose of any limited warranty or remedy herein.
          </p>
        </div>
      ),
    },
    {
      title: "General Provisions",
      children: (
        <div className="">
          <ul className="space-y-3">
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  01
                </p>

                <p>
                  <strong className="font-semibold ">
                    Assignment and Subcontracting:{" "}
                  </strong>
                  Except as set out below, neither party may assign or novate
                  this Agreement in whole or in part without the other party’s
                  express written consent. Company may
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  02
                </p>

                <p>
                  <strong className="font-semibold ">
                    {" "}
                    Modifications to the Agreement:{" "}
                  </strong>
                  Company may change this Agreement or any of its components by
                  updating this Agreement on Company.com. Changes to the
                  Agreement apply to any Entitlements acquired or renewed after
                  the date of modification.
                </p>
              </div>
            </li>
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  03
                </p>

                <p>
                  <strong className="font-semibold ">
                    Compliance with Laws:{" "}
                  </strong>
                  Each party will comply with all laws and regulations
                  applicable to their respective obligations under this
                  Agreement Company may restrict the availability of the Company
                  in any particular location or modify or discontinue features
                  to comply with applicable laws and regulations. You
                  acknowledge that You are the entity responsible for complying
                  with such laws.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  04
                </p>

                <p>
                  <strong className="font-semibold ">
                    {" "}
                    Governing Law and Venue:{" "}
                  </strong>
                  This Agreement, and any disputes arising from it, will be
                  governed exclusively by the applicable governing law of
                  Telangana in India. The courts located in Hyderabad in State
                  of Telangana will have exclusive jurisdiction to adjudicate
                  any dispute arising out of or relating to the Agreement or its
                  formation, interpretation or enforcement. Each party hereby
                  consents and submits to the exclusive jurisdiction of the
                  above-mentioned jurisdiction. Regardless of the governing law,
                  Company may seek interim injunctive relief in any court of
                  appropriate jurisdiction concerning any alleged breach of
                  Company’s intellectual property or proprietary rights.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  05
                </p>

                <p>
                  <strong className="font-semibold ">Force Majeure:</strong>
                  Except for payment obligations, neither party will be
                  responsible for failure to perform its obligations due to an
                  event or circumstances beyond its reasonable control.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  06
                </p>

                <p>
                  <strong className="font-semibold "> No Waiver: </strong>
                  Failure by either party to enforce any right under this
                  Agreement will not waive that right.
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  07
                </p>

                <p>
                  <strong className="font-semibold "> Severability: </strong>
                  If any portion of this Agreement is not enforceable, it will
                  not affect any other term
                </p>
              </div>
            </li>{" "}
            <li className="flex items-center">
              <div className="flex">
                <p className="font-openSans  my-1.5 font-semibold text-web-body-sm leading-[10px] text-brand-textGrey mr-3">
                  08
                </p>

                <p>
                  <strong className="font-semibold ">Entire Agreement: </strong>
                  This Agreement is the complete Agreement between the parties
                  concerning the subject matter of this Agreement and supersedes
                  all prior or contemporaneous communications, understandings or
                  agreements (whether written or oral).
                </p>
              </div>
            </li>
          </ul>
        </div>
      ),
    },
    {
      title: "Public Notice Aggregation Disclaimer",
      children: (
        <div className="space-y-5">
          <p>
            AuctionBazaar.com is an independent online marketplace that
            aggregates and displays auction-related information that is already
            available in the public domain through statutory notices, lender
            publications, government notifications, and other publicly
            accessible sources. We do not claim any association, authorization,
            mandate, or affiliation with any bank, financial institution, ARC,
            NBFC, or lender unless expressly stated.
          </p>
          <p>
            All information is hosted solely for informational and
            bidder-awareness purposes, without any alteration to the content of
            the public notice. AuctionBazaar.com does not publish confidential,
            internal, or non-public documents of any lender. The platform does
            not conduct auctions on behalf of lenders unless formally appointed,
            and does not guarantee the accuracy or completeness of the
            information published in such public notices. Users are advised to
            independently verify all auction details with the concerned lender
            before participating in any auction process. By using this platform,
            users acknowledge that AuctionBazaar.com operates strictly as a
            public-domain information aggregator, and not as an agent,
            representative, or authorized partner of any lender, unless
            specifically mentioned.
          </p>
        </div>
      ),
    },
  ];

  const goThroughContent = (
    <div className="mb-20">
      <p className="mb-8 font-openSans font-normal text-web-h3 leading-[30px] text-brand-bgBlack">
        Please read this End-User Terms and Conditions Agreement ('Agreement')
        carefully
      </p>
      <p className="font-openSans font-normal text-web-body-lg leading-5 text-brand-textGrey">
        The herein contained Agreement shall be considered a legally binding
        agreement between You (as an individual or an entity, who then shall,
        within the constraints of this agreement, be referred to as 'You' or
        'Your') and M/s. AUCTION BAZAAR.COM PRIVATE LIMITED with its registered
        office at H.NO 1-19-80/5/A ,P.NO.5, VIJAYAPURI COLONY, AYODHYA NAGAR
        SECUNDERABAD Rangareddi TG 500062 IN (hereinafter referred to as the
        “Company”) for the use of the specified platform Auctionbazaar.com
        ('Website'). Other aspects of the Website may also include, but are not
        limited to, software updates and any upgrades necessary that the Company
        may supply to You or make available to You, or that You could obtain
        after the initial copy of the Website, and as such that said items are
        not accompanied by a separate agreement or terms of use.
        <br />
        <br /> BY WAY OF THE INSTALLATION, COPYING, DOWNLOADING, ACCESSING OR
        OTHERWISE USE OF THIS WEBSITE, YOU ARE AGREEING TO BE LEGALLY BOUND BY
        THE HEREIN CONTAINED TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE TO BE
        BOUND BY THE TERMS OF THIS AGREEMENT, YOU THEN HAVE NO RIGHTS TO THE
        WEBSITE AND SHOULD THEREFORE NOT INSTALL, COPY, DOWNLOAD, ACCESS NOR USE
        THE WEBSITE.
      </p>
    </div>
  );

  return (
    <Layout
      heading="TERMS & CONDITIONS"
      subheading="Last updated on September, 2022"
      textContentData={termsAndConditionData}
      scrollerTopContent={goThroughContent}
    />
  );
};

export default TermsAndConditions;
